import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useProfileState,
  useProfileActions
} from './ProfileContext';

import { disassociateInterestWithAuthenticatedUser } from './restApi';

import styles from './ProfileUserInterest.module.scss';

const ProfileUserInterest = ({ interest }) => {
  const state = useProfileState();
  const { onResponse, onError } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  return state.user?.isAuthenticatedUser ? (
    <div key={interest.id} className={styles.userInterestWithRemoveBtn}>
      <p className={styles.displayedInterestNameWithRemoveBtn}>{interest.name}</p>
      <div className={styles.removeUserInterestBtnContainer}>
        <Button
          variant="primary"
          size='minimal'
          onClick={() => {
            disassociateInterestWithAuthenticatedUser(({
              body: {
                interestId: interest.id,
                authenticityToken,
              },
              onResponse,
              onError,
            }))
          }}
        >
          &#10005;
        </Button>
      </div>
    </div>
  ) : (
    <div key={interest.id} className={styles.userInterestWithoutRemoveBtn}>
      <p className={styles.displayedInterestNameWithoutRemoveBtn}>{interest.name}</p>
    </div>
  );
};

export default ProfileUserInterest;
